export enum ConversationType {
  USER = 'USER',
  SYSTEM = 'ASSISTANT',
  WORKFLOW = 'WORKFLOW',
  LOADING = 'LOADING',
  GENERAL_LEDGER = 'GENERAL_LEDGER'
}
